export const serverSendRequest = (url, serie, imei, number, amount, email, request, type, description) => () => {
      let token = localStorage["auth"]
      let urlSend = `${url}?emited=REQUEST&serie=${serie}&imei=${imei}&number=${number}&amount=${amount}&email=${email}&request=${request}&type=${type}&description=${description}`
      // console.log(urlSend)
      return fetch(urlSend, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
           // console.log('se obtiene ', r)
          if (r.error) {
            return Promise.reject(r.validation);
          }
          return r
      });
}

export const serverGetQR = (url, serie, imei, number, amount, request, emited, description) => () => {
  // console.log(url)
      let token = localStorage["auth"]
      let urlSend = `${url}?serie=${serie}&imei=${imei}&cedule=${number}&monto=${amount}&descripcion=${description}&emited=${emited}&solicitante=${request}`
      return fetch(urlSend, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          // console.log('se obtiene ', r)
          if (r.error) {
            return Promise.reject(r.validation);
          }
          return r
      });
}

export const serverPaymentRequest = (url, emited,  serie, imei, number, amount, email, request, type, descripcion, qrState, qrcode) => () => {
  // console.log(url)
      let token = localStorage["auth"]
      let urlSend = `${url}?emited=${emited}&serie=${serie}&imei=${imei}&number=${number}&amount=${amount}&email=${email}&request=${request}&type=${type}&descripcion=${descripcion}&qrState=${qrState}&qrcode=${qrcode}`
      return fetch(urlSend, {
        method: 'GET',
        headers: new Headers({ 'Content-type': 'application/json', 'Authorization': token})
      }).then(v => v.json())
      .then(r => {
          // console.log('se obtiene ', r)
          if (r.error) {
            return Promise.reject(r.validation);
          }
          return r
      });
}
  